module.exports = __webpack_public_path__ + "img/amenities-02.6531b317.jpg";